import React from 'react';
import classNames from 'classnames';

export type AttributesTableRowProps = {
  label: string;
  children?: React.ReactNode;
  className?: string;
};

export const AttributesTableRow = ({
  label,
  children,
  className,
}: AttributesTableRowProps) => (
  <div className={classNames('table-row mb-4', className)}>
    <dt className="table-cell py-1 pr-10 font-medium align-top">{label}</dt>
    <dd className="table-cell py-1">{children}</dd>
  </div>
);
